import {
  faChartLine,
  faCoins,
  faPeopleArrows,
  faTrophy,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import avatar from 'assets/img/no-pic.jpg';
import { Activity } from 'components/timeline/RecentActivity';
import { useUser } from 'context/UserContext';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ProfileBanner from './components/ProfileBanner';
import StartCard from './components/StartCard';

const ClassroomStarter = () => {
  const user = useUser();

  return (
    <>
      <ProfileBanner>
        <ProfileBanner.Header avatar={avatar} coverSrc="" />
        <ProfileBanner.Body>
          <Row>
            <Col lg={8}>
              <h4 className="mb-1">{user?.username}</h4>
            </Col>
          </Row>
        </ProfileBanner.Body>
      </ProfileBanner>
      <Card className="mb-3">
        <Card.Body>
          <Row className="justify-content-center">
            <Col xs={12} className="text-center mb-4">
              <div className="fs-8">Regolamento</div>
              <h3 className="fs-7 fs-md-6">Come funziona?</h3>
            </Col>
          </Row>

          <Activity
            activity={{
              title: 'Classe',
              text: (
                <span>
                  Per iniziare a giocare, è necessario{' '}
                  <strong>creare una classe</strong> o{' '}
                  <strong>unirsi ad una già presente su FantaClasse</strong>
                </span>
              ),
              icon: faTrophy,
              status: 'completed'
            }}
          />
          <Activity
            activity={{
              title: 'Crediti',
              text: (
                <span>
                  Ogni squadra ha a disposizione <b>100 crediti</b> per
                  acquistare i giocatori
                </span>
              ),
              icon: faCoins,
              status: 'completed'
            }}
          />
          <Activity
            activity={{
              title: 'Squadra',
              text: (
                <span>
                  Ogni squadra deve acquistare <b>1 professore</b> caposquadra e
                  <b> 4 alunni</b>
                </span>
              ),
              icon: faUsers,
              status: 'completed'
            }}
          />
          <Activity
            activity={{
              title: 'Giocatori',
              text: (
                <span>
                  Stessi <b>professori</b> o <b>alunni</b> possono essere
                  <b>contemporaneamente in più squadre</b>
                </span>
              ),
              icon: faPeopleArrows,
              status: 'completed'
            }}
          />
          <Activity
            activity={{
              title: 'Punteggi',
              text: (
                <span>
                  I <b>punteggi</b> di ogni giocatore vengono inseriti dal{' '}
                  <b>Capoclasse</b>
                </span>
              ),
              icon: faChartLine,
              status: 'completed'
            }}
          />

          <Row className="justify-content-center">
            <Col xs={12} className="text-center mb-4">
              <div className="fs-8">FantaClasse.it</div>
              <h3 className="fs-7 fs-md-6">
                Pronto alla competizione?<br></br>Inizia subito!
              </h3>
            </Col>
            <Col xs={12} lg={9} xl={10} xxl={8}>
              <Row>
                <StartCard
                  title="Crea la tua classe"
                  subtitle={
                    <span>
                      <strong>Aggiungi la tua classe</strong> su FantaClasse e{' '}
                      <strong>invita i tuoi compagni!</strong>
                    </span>
                  }
                  features={[
                    'Diventa capoclasse',
                    'Aggiungi alunni e professori',
                    'Gestisci bonus e malus',
                    'Crea nuove regole'
                  ]}
                  buttonText="Crea la tua classe"
                  buttonLink="/classe/nuova"
                />
                <StartCard
                  title="Unisciti ad una classe"
                  subtitle={
                    <span>
                      Inserisci il <strong>Codice Classe</strong>
                      <br /> e <strong>inizia subito a giocare!</strong>
                      <br />
                      <br />
                    </span>
                  }
                  features={[
                    'Crea la tua squadra',
                    'Gioca contro i tuoi compagni',
                    'Scala la classifica',
                    'Dai inizio alla competizione'
                  ]}
                  buttonText="Unisciti a una classe"
                  isJoin
                />
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default ClassroomStarter;
